// extracted by mini-css-extract-plugin
export default {"data":"_3Gmp","animatedBackground":"_1s7i","placeHolderShimmer":"_3obh","placeholderText":"_3FdD"};